import { useTranslation } from 'react-i18next'

import { stopPropagation } from '../../../../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import { ListItemIcons } from '../../../../../ListItem'
import { REQUEST_PROFILE_WIDGET_PROVIDERS_ADD_RECOMMENDED_PROVIDER_QA_NAME } from '../../RequestProfileWidgetProviders.constants'

import PlusIcon from '../../../../../../icons/plus.svg'

function RequestProfileWidgetProvidersRecommendedProviderAddButton({
  isDisabled,
  itemId,
  onClick,
}) {
  const { t } = useTranslation()

  function handleClick(event) {
    stopPropagation(event)
    onClick?.(itemId)
  }

  return (
    <ListItemIcons>
      <Button.Outlined
        isGrey
        beforeIconProps={{
          Icon: PlusIcon,
        }}
        disabled={isDisabled}
        height={BUTTON_HEIGHT_32}
        qaName={
          REQUEST_PROFILE_WIDGET_PROVIDERS_ADD_RECOMMENDED_PROVIDER_QA_NAME
        }
        tooltip={t('RequestProfile.ProvidersAddRecommendedProviderTooltipKey')}
        onClick={handleClick}
      />
    </ListItemIcons>
  )
}

export default RequestProfileWidgetProvidersRecommendedProviderAddButton
